import React from 'react'
import Link from 'gatsby-link'
import styles from "./index.module.css"
import SvgLogo from '../../../images/logo-ludovica.svg'
import SvgMenu from '../../../images/hamburger-icon.svg'

const ListLink = props =>
    <Link to={props.to}>
  <li style={{
    display: `inline-block`,
    whiteSpace: 'nowrap',
    padding: '0 2em',
    margin: 0
    }}>
      {props.children}
  </li>
    </Link>

const Header = () => (
  <div
    style={{
      background: 'transparent'
    }}
  >
    <div
      style={{
        margin: '0 auto',
        maxWidth: 1366,
        padding: '1.45rem 1.0875rem',
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '32px',
        alignItems: 'center'
      }}
    >
        <Link
          to="/"
          style={{
            textDecoration: 'none',
            height: '1em'
          }}
          className="logo"
        >
          <SvgLogo/>
        </Link>
      <div
      style={{
          position: 'relative',
          zIndex: '998',
          height: '1em',
          width: '1em'
      }} >
          <SvgMenu/>
          <input type="checkbox" id="nav-trigger" className={styles['nav-trigger']} style={{
              position: 'absolute',
              left: '0',
              top: '0'
          }} />
          <label htmlFor="nav-trigger">
          </label>
          <ul className={styles['menu-list']}>
            <ListLink to="/a-propos/">À propos</ListLink>
            <ListLink to="/une-ville-fabulee/">Une ville fabulée</ListLink>
            <ListLink to="/long-metrage/">Long métrage</ListLink>
            <ListLink to="/digestifs-et-bonne-compagnie/">Digestifs et compagnie</ListLink>
            <ListLink to="/le-coin-du-flaneur/">Le coin du fl&acirc;neur</ListLink>
          </ul>
      </div>
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js